import { ButtonMedium } from '@components/core-ui/form-elements/buttons/Button/variations/PrimaryButtonSizes';
import CheckEmail from '@components/icons/CheckEmail.svg';
import { useInitContext } from '@providers/InitProvider';
import React from 'react';
import { Wrapper } from './styles';
import { StyledIconWrapper } from './styles/StyledIconWrapper';

export const RateLimitPage = () => {
  const { logout } = useInitContext();

  const goToLogin = (evt: React.MouseEvent<HTMLButtonElement>) => {
    evt.preventDefault();
    logout();
  };

  return (
    <Wrapper>
      <div className="root">
        <StyledIconWrapper>
          <CheckEmail className="checkEmailIcon" />
        </StyledIconWrapper>
        <h1 className="great">Error!</h1>
        <h2 className="accountDeactivated">You made too many requests to our servers</h2>
        <h2 className="pleaseContact">
          Please do not use automation software on this website otherwise your account will be blocked
        </h2>

        <ButtonMedium onClick={goToLogin}>Sign In</ButtonMedium>
      </div>
    </Wrapper>
  );
};
